export const downloadTypes = Object.freeze({
  picture: 'picture',
  excel: 'excel',
  monthlyExcel: 'monthly_excel'
})
